import { AddPrinterParams } from './printers.model';

const CONTEXT = '[Printers]';

export class LoadPrinters {
  static readonly type = `${CONTEXT} Load Printers`;
}

export class LoadPrinterTypes {
  static readonly type = `${CONTEXT} Load Printer Types`;
}

export class AddPrinter {
  static readonly type = `${CONTEXT} Add Printer`;
  constructor(public payload: AddPrinterParams) {}
}

export class UpdatePrinter {
  static readonly type = `${CONTEXT} Update Printer`;
  constructor(
    public id: number,
    public payload: AddPrinterParams,
  ) {}
}

export class DeletePrinter {
  static readonly type = `${CONTEXT} Delete Printer`;
  constructor(public id: number) {}
}
